export default __webpack_public_path__ + "static/media/MiniTape_SideA_14_Schützenfest1.a9ae94ac.mp3";